// Pure catalog/sample helpers for the browser mapping workbench.
import { termSchemaLabel } from './schema_label.js';

export function valueSchemeFor(catalog, termId) {
  const term = catalog?.terms?.find((candidate) => candidate.id === termId);
  if (!term?.valueScheme) return null;
  return catalog?.valueSchemes?.find((scheme) => scheme.id === term.valueScheme) ?? null;
}

export function schemeConcepts(scheme) {
  if (!scheme) return [];
  if (scheme.concepts) return scheme.concepts;
  return (scheme.members ?? []).map((id) => ({ id, label: id.split(/[:/#]/).at(-1) }));
}

export function sourceValueOptions(rows, source, map = {}) {
  const counts = new Map();
  for (const row of rows ?? []) {
    const value = String(row?.[source] ?? '').trim();
    if (value) counts.set(value, (counts.get(value) ?? 0) + 1);
  }
  return [...counts].map(([value, count]) => ({ value, count, mapped: value in map }))
    .sort((a, b) => b.count - a.count || a.value.localeCompare(b.value));
}

export function catalogTermMatches(catalog, term, query) {
  const needle = String(query ?? '').trim().toLowerCase();
  if (!needle) return true;
  const scheme = term?.valueScheme
    ? catalog?.valueSchemes?.find((candidate) => candidate.id === term.valueScheme)
    : null;
  const records = Array.isArray(term?.record) ? term.record : [term?.record];
  const searchable = [term?.id, term?.means, term?.from, term && termSchemaLabel(catalog, term.id), ...records, scheme?.id, scheme?.means,
    ...schemeConcepts(scheme).flatMap((concept) => [concept.id, concept.label, ...(concept.aliases ?? [])])];
  return searchable.some((value) => String(value ?? '').toLowerCase().includes(needle));
}
